import gql from 'graphql-tag';
import { productControlUnitFragment, productFragment, productMountingKitFragment } from '../../products/api/fragments';

export const cartItemFragment = gql`
  ${productFragment}
  ${productControlUnitFragment}
  ${productMountingKitFragment}

  fragment CartItemFragment on CartItem {
    id
    sku
    title
    description
    note
    quantity
    price
    totals {
      subtotal
      vat
      total
      shipping
    }
    createdAt
    updatedAt
    product {
      ...ProductFragment
      ...ProductControlUnitFragment
      ...ProductMountingKitFragment
    }
    configuration {
      id
      class
      series
      family
      housingType
      sizeUpper
      sealMaterial
      operationPressureLabelLaser
      materialInsert
      actuation
      apzLb
      controlUnitSeries
      amountOfSolenoids
      controlUnitCommunicationProtocol
      controlUnitConnection
    }
    details {
      key
      value
    }
  }
`;

export const cartFragment = gql`
  ${cartItemFragment}

  fragment CartFragment on Cart {
    id
    items {
      ...CartItemFragment
    }
    totalItemCount
    totals {
      subtotal
      vat
      total
      shipping
    }
    createdAt
    updatedAt
  }
`;
